<template>
  <div class="container">
    <ToolbarContainer
      class="toolbarContainer"
    >
      <template v-slot:toolbar>
        <Container
          class="titleContainer"
        >
          <HeadingMedium>{{ $options.pageTitle }}</HeadingMedium>
        </Container>
        <Banner
          v-if="activatingBannerText"
          :bannerText="activatingBannerText"
          bannerType="informational"
          :canCloseBanner="false"
          class="banner"
          :data-test-id="$testId('activatingBanner')"
          icon="info"
          :isMarkdown="false"
          showBanner
        />
        <Banner
          v-if="errorBannerText"
          :bannerText="errorBannerText"
          bannerType="error"
          :canCloseBanner="false"
          class="banner"
          :data-test-id="$testId('errorBanner')"
          icon="info"
          :isMarkdown="false"
          :learnMoreLink="$options.kbArticles.removeAwsAccounts"
          learnMoreText="Learn more"
          showBanner
        />
        <UpgradeNudge
          class="upgradeNudge"
          :data-test-id="$testId('upgradeNudge')"
        />
      </template>
      <template v-slot:body>
        <ManageAccountTable
          data-test-id="ManageAccountPanel__accountTable"
          :refreshKey="refreshKey"
          @addAccountButtonClick="handleAddAccountButtonClick"
        />
      </template>
    </ToolbarContainer>
    <AddAccountModal
      :showModal="showModal"
      @activate="handleActivate"
      @cancel="hideModal"
    />
  </div>
</template>

<script>
import {
  Banner,
  Container,
  HeadingMedium,
  ToolbarContainer,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { filter } from 'lodash';
import { mapGetters } from 'vuex';
import AddAccountModal from 'client/CloudInsights/components/AddAccountModal.vue';
import ManageAccountConstants from 'client/CloudInsights/constants/ManageAccountConstants';
import ManageAccountTable from 'client/CloudInsights/ManageAccounts/ManageAccountTable.vue';
import UpgradeNudge from 'client/components/Nudge/UpgradeNudge.vue';

const { accountState, kbArticles } = ManageAccountConstants;
const cloudInsightsAccountsModule = StoreModuleMap[ItemTypeConsts.cloudInsightsAccounts];
const pageTitle = 'Manage Accounts';

export default {
  name: 'ManageAccountsPanel',

  components: {
    AddAccountModal,
    Banner,
    Container,
    HeadingMedium,
    ManageAccountTable,
    ToolbarContainer,
    UpgradeNudge,
  },

  pageTitle,
  kbArticles,

  data() {
    return {
      refreshKey: 0,
      showModal: false,
      showBanner: false,
    };
  },

  computed: {
    ...mapGetters(cloudInsightsAccountsModule, {
      accounts: 'getCollection',
    }),

    activatingBannerText() {
      let accountText;

      const pending = filter(this.accounts, (a) => a.statusType === accountState.pending);
      if (pending.length === 1) {
        const [account] = pending;
        accountText = account.awsAccountId;
      } else if (pending.length > 1) {
        accountText = `${pending.length} accounts`;
      } else {
        return '';
      }

      return `We are currently working on activating ${accountText}. We will notify you when the task is complete.`;
    },

    errorBannerText() {
      const accounts = filter(this.accounts, a => a.statusType === accountState.error)
        .map(a => a.awsAccountId);

      if (accounts.length === 0) return '';

      return `Need help activating your account(s)? ${accounts.join(', ')}`;
    },
  },

  methods: {
    handleActivate() {
      this.refreshKey += 1;
      this.hideModal();
    },

    handleAddAccountButtonClick() {
      this.showModal = true;
    },

    hideModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>

.banner {
  border-bottom: 1px solid var(--jc-border-color);
  height: 50px;
}

.container {
  height: 100%;
}

.titleContainer {
  border-bottom: 1px solid var(--jc-border-color);
}

.toolbarContainer {
  grid-template-rows: auto auto auto 1fr !important;
}

.upgradeNudge {
  margin-bottom: var(--jc-spacer-small);
}
</style>
